import { getAPIHeaders } from '@/services/api.service';
function mapTransaction(item) {
    return item
        ? {
              ...item,
              createdAt: item.createdAt ? new Date(item.createdAt) : null,
              createdBy: item.createdBy ? new Date(item.createdBy) : null,
              updatedAt: item.updatedAt ? new Date(item.updatedAt) : null,
              updatedBy: item.updatedBy ? new Date(item.updatedBy) : null,
              validatedOn: item.validatedOn ? new Date(item.validatedOn) : null,
              expireAt: item.expireAt ? new Date(item.expireAt) : null,
              billingDate: item.billingDate ? new Date(item.billingDate) : null,
          }
        : null;
}

export async function getTransactions() {
    const response = await fetch(`/api/transactions`, {
        headers: getAPIHeaders(),
    });
    return (await response.json()).map(mapTransaction);
}
